interface SelectOption {
  value: string;
  label: string;
}

interface SelectProps {
  label: string;
  id: string;
  value: string;
  onChange: (value: string) => void;
  options: SelectOption[];
  required?: boolean;
  error?: string;
  'data-testid'?: string;
}

export function Select({
  label,
  id,
  value,
  onChange,
  options,
  required = false,
  error,
  'data-testid': testId,
}: SelectProps) {
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={id} className="field-label block">
        {label}
        {required && <span className="text-[var(--color-accent)] ml-1">*</span>}
      </label>
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        data-testid={testId}
        className="bg-[var(--color-elevated)] rounded-md text-body-md text-[var(--color-text-primary)] px-3 py-2.5 w-full focus:outline-none focus:ring-2 focus:ring-[var(--color-accent)] focus:ring-offset-0"
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value} className="bg-[var(--color-elevated)]">
            {opt.label}
          </option>
        ))}
      </select>
      {error && <p className="text-body-xs text-[var(--color-accent)]">{error}</p>}
    </div>
  );
}
